import React from 'react';

// components
import NotificationPreferences from '../../modules/Profile/AccountNotifications/NotificationPreferences';

const AccountNotifications = () => {
  return <NotificationPreferences />;
};

export default AccountNotifications;
